// src/api/useDeleteAgenda.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/api";

const deleteAgenda = async (agendaId) => {
  return api.delete(`/agenda/${agendaId}`);
};

export const useDeleteAgendaQuery = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteAgenda,
  });
};
